/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import Promise from 'bluebird';
import eventDispatcher from '@bingads-webui-component-legacy/event-dispatcher/index';

export const welcomeCardConfig = [
  {
    // Welcome Tips Card
    validFor: ['account'],
    typeId: 'CardType-WelcomeTips',
    name: 'WelcomeTipsCard',
    cssKey: 'tips-and-opportunities',
    titleKey: 'Dashboard_Tips_Card_Title',
    contentType: 'WelcomeTipsCard',
    sizeOption: {
      small: {
        width: 12,
        supportedWidth: [12],
      },
      medium: {
        width: 6,
        supportedWidth: [6],
      },
    },
  },
];

welcomeCardConfig.getContentConstructor = ({
  contentType,
  constants,
  instrumentation,
}) => new Promise((resolve) => {
  const i18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/dashboard-cards');
  const deps = {
    i18n,
    eventDispatcher,
  };

  switch (contentType) {
    case 'WelcomeTipsCard':
      import(/* webpackMode: 'eager' */ '@bingads-webui-campaign-legacy/dashboard-cards/welcome-tips-card/index').then((contentConstructor) => {
        resolve({
          contentConstructor: contentConstructor.default,
          deps,
        });
      });
      break;
    default:
      resolve();
      instrumentation.logMessage(
        [constants.LOGCATEGORY.ERROR],
        constants.LOGLEVEL.INFO,
        'dashboard/dashboard-view',
        `Unknown card content: ${contentType}`
      );
  }
});
